import { VisitReportsStoreState } from './visitReportsData.state';
import { RootReducerState } from './../ngrx.imports';
import { createSelector } from '@ngrx/store';

export const getVisitReportsState = (state: RootReducerState) => state.visitReports;


//Selectors
export const getVisitReportsAllData = (state: VisitReportsStoreState) => state.visitReports;
export const selectorVisitReportsAllData = createSelector(getVisitReportsState,getVisitReportsAllData);
